export var getCardSx = function (showHover, isSelected, isSelectable) {
    return {
        backgroundColor: 'white',
        borderRadius: 3,
        borderWidth: 1,
        borderStyle: isSelectable ? 'solid' : 'none',
        borderColor: isSelected ? 'primary' : 'transparent',
        transition: 'box-shadow 0.5s',
        boxShadow: 3,
        '&:hover': {
            boxShadow: showHover ? 4 : 3,
        },
        '&:focus': {
            outlineStyle: 'solid',
            outlineColor: 'transparent',
            transition: 'none',
            boxShadow: function (theme) { var _a, _b; return "0 0 0 2px white, 0 0 0 5px ".concat((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.primary, ", ").concat((_b = theme.shadows) === null || _b === void 0 ? void 0 : _b[4]); },
        },
    };
};
export var getCardMediaScreenSx = function (showHover, isSelected, isSelectable) {
    return {
        '@media screen and (min-width: 30em)': {
            backgroundColor: 'white',
            borderRadius: 3,
            borderWidth: 1,
            borderStyle: isSelectable ? 'solid' : 'none',
            borderColor: isSelected ? 'yellow' : 'transparent',
            transition: 'box-shadow 0.5s',
            boxShadow: 3,
            '&:hover': {
                boxShadow: showHover ? 4 : 3,
            },
            '&:focus': {
                outlineStyle: 'solid',
                outlineColor: 'transparent',
                transition: 'none',
                boxShadow: function (theme) { var _a, _b; return "0 0 0 2px white, 0 0 0 5px ".concat((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.primary, ", ").concat((_b = theme.shadows) === null || _b === void 0 ? void 0 : _b[4]); },
            },
        },
    };
};
export var cardDividerSx = {
    left: '0',
    right: '0',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderColor: 'gray-20',
};
